
export function set_group({ commit }, payload ){

  commit('SET_GROUP',payload);
    
}